export enum WidgetDatasourceEnum {
  servicesStatusTotals = 'servicesStatusTotals',
  agentsStatusTotal = 'agentsStatusTotal',
  agentsTracking = 'agentsTracking',
  agentsLocations= 'agentsLocations',
  agentsDetails = 'agentsDetails',
  serviceDetails = 'serviceDetails',
  agentsRoutesScore = 'agentsRoutesScore',
  totalRoutesScore = 'totalRoutesScore',
  ordersTotal = 'ordersTotal',
  ordersStatusTotal = 'ordersStatusTotal',
  uniqueServiceFieldCount = 'uniqueServiceFieldCount'
}
